import { Box, Button, Card, Modal, Typography } from "@mui/material";
import { icons } from "../../assets/icons/icons";
import { colors } from "../../values/colors";

const EndAuctionModal = ({
  open,
  onClose,
  onEnd,
  onReAuction,
  playersSold,
  playersUnsold,
}) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Card
        sx={{
          width: 400,
          px: 3,
          py: 6,
          borderRadius: "16px",
          boxShadow: "0px 4px 25px rgba(0,0,0,0.15)",
          textAlign: "center",
        }}
      >
        <img src={icons.greenTick2} alt="warn" />
        <Typography sx={{ fontSize: "1.2rem", fontWeight: "600", my: "1rem" }}>
          Auction Ended Successfully
        </Typography>
        <Box sx={{ display: "flex", gap: "4rem", justifyContent: "center" }}>
          <Box
            sx={{
              p: 2,

              height: 125,
              width: 125,
              borderRadius: "12px",
              background: "##FFFFFF",
              boxShadow: "0px 22.61px 22.61px 0px #7E7E7E1C",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography sx={{ fontSize: "1.6rem", fontWeight: 600 }}>
              {playersSold}
            </Typography>
            <Typography
              sx={{
                fontSize: "17px",
                fontWeight: 600,
                textAlign: "center",
                color: "#535964",
              }}
            >
              PLAYERS SOLD
            </Typography>
          </Box>
          <Box
            sx={{
              p: 2,
              height: 125,
              width: 125,
              borderRadius: "12px",
              background: "##FFFFFF",
              boxShadow: "0px 22.61px 22.61px 0px #7E7E7E1C",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography sx={{ fontSize: "1.6rem", fontWeight: 600 }}>
              {playersUnsold}
            </Typography>
            <Typography
              sx={{
                fontSize: "17px",
                fontWeight: 600,
                textAlign: "center",
                color: "#535964",
              }}
            >
              PLAYERS UNSOLD
            </Typography>
          </Box>
        </Box>
        <Box
          sx={{
            mt: 3,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            gap: "1.5rem",
          }}
        >
          {/* <Button
            variant="contained"
            onClick={onEnd}
            sx={{
              background: colors.linearGradent,
              color: "#fff",
              textTransform: "none",
              borderRadius: "999px",
              py: ".9rem",
              fontSize: "1rem",
              //   width: "120px",
            }}
          >
            End Auction
          </Button> */}
          <Button
            variant="contained"
            onClick={onReAuction}
            sx={{
              background: colors.linearGradent,
              color: "#fff",
              textTransform: "none",
              py: ".9rem",
              borderRadius: "999px",
              fontSize: "1rem",
              //   width: "120px",
            }}
          >
            Set Up Re-Auction
          </Button>
        </Box>
      </Card>
    </Modal>
  );
};

export default EndAuctionModal;
